import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { languages } from 'i18n/options';
import Flex, { Box } from 'components/Flex';
import TextLink from 'components/TextLink';
import Text from 'components/Text';
import TooltipButton from 'components/TooltipButton';
var languagesMap = languages.reduce(function (map, language) {
  map[language.value] = language.title_en;
  return map;
}, {});
function SubtitlesItem(_ref) {
  var isDisabled = _ref.isDisabled,
    subtitleFile = _ref.subtitleFile,
    isMutable = _ref.isMutable,
    onEdit = _ref.onEdit,
    onDelete = _ref.onDelete;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var id = subtitleFile.id,
    locale = subtitleFile.locale,
    name = subtitleFile.name,
    filename = subtitleFile.filename;
  var label = languagesMap[locale] || locale;
  return /*#__PURE__*/React.createElement(Flex, {
    background: "shaded",
    borderRadius: "small",
    overflow: "hidden"
  }, /*#__PURE__*/React.createElement(Box, {
    grow: true,
    shrink: true,
    bold: true,
    position: "relative",
    overflow: "ellipsis",
    fontSize: "xs",
    lineHeight: 1.3,
    p: "xs",
    pl: "s"
  }, /*#__PURE__*/React.createElement(TextLink, {
    stealthy: true,
    as: "button",
    onClick: function onClick() {
      return onEdit({
        subtitleFile: subtitleFile
      });
    },
    isDisabled: isDisabled
  }, /*#__PURE__*/React.createElement(Box, {
    fillParent: true,
    z: function z(theme) {
      return theme.globals.z.raised - 1;
    }
  }), label), /*#__PURE__*/React.createElement(Text, {
    as: "p",
    dimmed: true,
    bold: false
  }, name || filename)), isMutable && /*#__PURE__*/React.createElement(Box, {
    pr: "xs"
  }, /*#__PURE__*/React.createElement(TooltipButton, {
    size: "small",
    variant: "transparent",
    icon: "x",
    title: "".concat(t('actions_delete'), " ").concat(label),
    tooltipPlacement: "top-end",
    onClick: function onClick() {
      return onDelete({
        id: id
      });
    },
    isDisabled: isDisabled
  })));
}
export default SubtitlesItem;